import { render } from "./AddReceptionHCPage.vue?vue&type=template&id=35d07a56&ts=true"
import script from "./AddReceptionHCPage.vue?vue&type=script&lang=ts"
export * from "./AddReceptionHCPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__